import { useLocation } from 'react-router';
import { NavBarMenuItem } from './NavBarMenuItem';
import { NavBarUser } from './NavBarUser';

export const NavBarMenu = () => {
  const { pathname } = useLocation();
  const isRoot = pathname === '/';

  return (
    <nav className="flex flex-row justify-between gap-x-8">
      <NavBarMenuItem label="AWMS" path="/" />
      {!isRoot ? (
        <>
          <NavBarMenuItem label="School staff" path="/staffs" />
          <NavBarMenuItem label="School units" path="/unit-workloads" />
          <NavBarMenuItem label="Reports" path="/reports" />
        </>
      ) : (
        ''
      )}
      <NavBarUser />
    </nav>
  );
};
